import { AssignmentDetails } from '../assignmentType';

export const fetchTurnitinLaunchRequest = async ({
  assignmentDetails,
  ltiConsumerEndpoint,
  spaceId,
  sessionToken,
  userId,
}: {
  assignmentDetails: AssignmentDetails;
  ltiConsumerEndpoint: string;
  spaceId: string;
  sessionToken: string;
  userId: string;
}) => {
  if (!assignmentDetails) {
    return null;
  }
  const { id, endDate: dueDate, startDate, title } = assignmentDetails;

  const result = await fetch(`${ltiConsumerEndpoint}`, {
    method: 'post',
    body: JSON.stringify({
      assignmentId: id,
      startDate,
      dueDate,
      title,
      spaceId,
    }),
    headers: {
      'Content-Type': 'application/json',
      'x-session-token': sessionToken,
      'x-user-id': userId,
    },
  });

  const request = await result.json();
  if (request?.errors?.length > 0) {
    // eslint-disable-next-line no-console
    console.error(request.errors[0]);
  }

  return request;
};
